import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PAGE_SEO = {
	'/': {
		title: 'ape.store — make a meme, launch it in seconds',
		description: 'Launch a memecoin in seconds on Base, Ethereum, BNB Chain and Robinhood. Fair launch, liquidity locked forever, 80% of trading fees to the creator.',
		image: '/img/og-home.png',
	},
	'/new-pairs': {
		title: 'New Pairs — live memecoin pairs, minted in real time · ape.store',
		description: 'Every memecoin minted on Base, Ethereum, BNB Chain and Robinhood, streaming live. Filter by network, graduation or market cap, and trade in one click.',
		image: '/img/og-home.png',
	},
	'/new-token': {
		title: 'Create a token — launch a memecoin in seconds · ape.store',
		description: 'Name it, upload the art, pick a chain, deploy. No code, no presale — you pay gas and nothing else, and 80% of trading fees stream back to you.',
		image: '/img/og-new-token.png',
	},
	'/airdrop': {
		title: 'Airdrop — trade to stack points for $APES · ape.store',
		description: 'Every $100 traded earns 10 points. Finish the missions, climb the points leaderboard, and convert your balance to $APES at each drop.',
		image: '/img/og-airdrop.png',
	},
	'/docs': {
		title: 'How it works — fair launch, locked liquidity · ape.store',
		description: 'How bonding-curve launches work: what graduation means, how liquidity locks permanently, and where the 80% creator fee comes from.',
		image: '/img/og-docs.png',
	},
	'/my-apes': {
		title: 'My Apes — your token portfolio · ape.store',
		description: 'View and manage all the memecoins in your wallet, track market cap and trading activity.',
		image: '/img/og-home.png',
	},
	'/profile': {
		title: 'Profile · ape.store',
		description: 'Your ape.store profile, referral stats and trading history.',
		image: '/img/og-home.png',
	},
	'/bridge': {
		title: 'Bridge — cross-chain transfers · ape.store',
		description: 'Bridge tokens between Base, Ethereum, BNB Chain and more.',
		image: '/img/og-home.png',
	},
	'/leaderboard': {
		title: 'Leaderboard — top memecoin traders by profit · ape.store',
		description: 'The top ape.store traders by realized profit over the last seven days.',
		image: '/img/og-leaderboard.png',
	},
};

const DEFAULT_TITLE = 'ape.store — make a meme, launch it in seconds';
const DEFAULT_DESC = 'Launch a memecoin in seconds on Base, Ethereum, BNB Chain and Robinhood. Fair launch, liquidity locked forever, 80% of trading fees to the creator.';
const DEFAULT_IMAGE = '/img/og-home.png';

function setMeta(name, content) {
	const el = document.querySelector(`meta[name="${name}"], meta[property="${name}"]`);
	if (el) el.setAttribute('content', content);
}

export function useSEO() {
	const { pathname } = useLocation();

	useEffect(() => {
		const page = PAGE_SEO[pathname];

		if (page) {
			document.title = page.title;
			setMeta('description', page.description);
			setMeta('og:title', page.title);
			setMeta('og:description', page.description);
			setMeta('og:image', page.image || DEFAULT_IMAGE);
			setMeta('twitter:title', page.title);
			setMeta('twitter:description', page.description);
			setMeta('twitter:image', page.image || DEFAULT_IMAGE);
		} else {
			document.title = DEFAULT_TITLE;
			setMeta('description', DEFAULT_DESC);
			setMeta('og:image', DEFAULT_IMAGE);
			setMeta('twitter:image', DEFAULT_IMAGE);
		}
	}, [pathname]);
}

function formatCompact(value) {
	if (!value || value === 0) return '$0';
	return '$' + Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(value);
}

function formatPrice(value) {
	if (!value || value === 0) return '$0';
	return '$' + value.toFixed(6);
}

export function useTokenSEO(token, marketCap, price) {
	useEffect(() => {
		if (!token) return;
		const mcap = marketCap || token.marketCap || 0;
		const p = price || (mcap / 1e9);
		const holders = token.volumeStat?.transactions || token.holders || 0;
		const title = `${token.name} ($${token.symbol}) price, chart and holders · ape.store`;
		const desc = `${token.name} ($${token.symbol}) on ape.store — ${formatCompact(mcap)} market cap, ${formatPrice(p)} per token, ${holders} holders. Live chart and trades.`;
		const image = `/api/token/${token.chain}/${token.address}/image`;
		document.title = title;
		setMeta('description', desc);
		setMeta('og:title', title);
		setMeta('og:description', desc);
		setMeta('og:image', image);
		setMeta('twitter:title', title);
		setMeta('twitter:description', desc);
		setMeta('twitter:image', image);
	}, [token, marketCap, price]);
}
